import { render, staticRenderFns } from "./MessageFeedback.vue?vue&type=template&id=5528d344&scoped=true"
import script from "./MessageFeedback.vue?vue&type=script&lang=js"
export * from "./MessageFeedback.vue?vue&type=script&lang=js"
import style0 from "./MessageFeedback.vue?vue&type=style&index=0&id=5528d344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5528d344",
  null
  
)

export default component.exports